import dbflex from "@/util/dbflex";
import Vue from "vue";

var plugin = new Vue();
export default {
  namespaced: true,
  state: {
    visibility: false,
    tahun: {
      loading: false,
      data: [],
      active: {},
    },
    status: {
      loading: false,
      data: [],
      active: {},
    },
  },
  mutations: {
    setTahunLoading(state, loading) {
      state.tahun.loading = loading;
    },
    resetDataTahun(state) {
      state.tahun.data = [];
    },
    setDataTahun(state, tahun) {
      state.tahun.data = tahun;
    },
    setStatusLoading(state, loading) {
      state.status.loading = loading;
    },
    resetDataStatus(state) {
      state.status.data = [];
    },
    setDataStatus(state, status) {
      state.status.data = status;
    },
    setActiveStatus(state, status) {
      state.status.active = status;
    },
    setActiveTahun(state, tahun) {
      state.tahun.active = tahun;
    },
    setVisibility(state, visibility) {
      state.visibility = visibility;
    },
  },
  actions: {
    init(context) {
      let tahun = parseInt(localStorage.getItem("tahun"));
      let status = localStorage.getItem("status");

      context.dispatch("setTahun", tahun);
      context.dispatch("setStatus", status);
    },
    setVisibility(context, payload) {
      context.commit("setVisibility", !!payload);
    },
    setTahun(context, payload = -1) {
      if (payload && payload >= 0) {
        localStorage.setItem("tahun", payload);

        // reset status
        localStorage.removeItem("status");
        context.commit("setActiveStatus", "");

        context.commit("setActiveTahun", payload);
        context.dispatch("refreshStatus", payload);
      }
    },
    setStatus(context, payload = "") {
      if (payload) {
        localStorage.setItem("status", payload);
        context.commit("setActiveStatus", payload);
      }
    },
    refreshTahun(context) {
      context.commit("setTahunLoading", true);
      context.commit("resetDataTahun");
      plugin.$axios
        .post("/administration/tahun/list", {})
        .then((res) => {
          const result = res.data;
          context.commit("setDataTahun", result.Data || []);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          context.commit("setTahunLoading", false);
        });
    },
    refreshStatus(context, payload = -1) {
      if (payload && payload >= 0) {
        context.commit("setStatusLoading", true);
        context.commit("resetDataStatus");

        let filter = new dbflex();
        filter.eq("Tahun", payload);
        let param = { Filter: filter.get() };
        plugin.$axios
          .post("/administration/status_anggaran/list", param)
          .then((res) => {
            const result = res.data;

            // setting default status with first status when exist
            if (result.Data.length > 0 && !context.state.status.active) {
              const first = result.Data[0];
              context.dispatch("setStatus", first.StatusAnggaran);
            }
            context.commit("setDataStatus", result.Data || []);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            context.commit("setStatusLoading", false);
          });
      }
    },
  },
  getters: {
    itemTahunEmpty(state) {
      return state.tahun.data.length == 0;
    },
    tahunLoading(state) {
      return state.tahun.loading;
    },
    itemStatusEmpty(state) {
      return state.status.data.length == 0;
    },
    statusLoading(state) {
      return state.status.loading;
    },
    activeStatus(state) {
      return state.status.active;
    },
    activeTahun(state) {
      return state.tahun.active;
    },
  },
};
